var _linearGradient, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDodoToken = function SvgDodoToken(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 50 50",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "4.518272%",
    x2: "100%",
    y1: "-4.372756%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffc2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efe806"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    fill: "url(#a)",
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.4338561 8c1.1351178 0 2.0552634 1.6770428 2.0552634 3.7454141 0 .0500278-.0009047.0994997-.0019904.1489717.6094494-.74597 1.3205945-1.1158051 1.8632723-.879748.5519064.2401334.7866024 1.0461367.6749544 2.0385399-.0273239.4702612-.1406004.9866592-.3456201 1.5039837-.118886.2999815-.2602103.5773578-.4160108.8273115 8.0887771 1.8512136 13.825166 8.7040948 13.7352324 20.6155271h-4.9230055c.0763621-10.0963498-5.6089981-15.0813415-13.048154-15.2380952-8.1010819-.1706504-12.5852765 5.3913285-13.1044304 15.2380952h-4.9233674c.63080192-11.9610895 5.6413886-19.2490272 14.4431202-20.681675-.1407814-.2106726-.4002679-.63665-.5158968-.8845655-.6899736-1.4773022-.5918971-2.9985177.218953-3.3979989.6483544-.3192514 1.5560143.176209 2.2465307 1.1432277-.0090477-.1423013-.0141144-.286826-.0141144-.4335742 0-2.0683713.9201457-3.7454141 2.0552634-3.7454141zm-4.4955465 18.5747867c.5931945 0 1.0742113.5509279 1.0742113 1.2301418v3.0216193c0 .6794401-.4810168 1.2301419-1.0742113 1.2301419-.5933927 0-1.0744094-.5507018-1.0744094-1.2301419v-3.0216193c0-.6792139.4810167-1.2301418 1.0744094-1.2301418zm8.5942848 0c.5933927 0 1.0744094.5509279 1.0744094 1.2301418v3.0216193c0 .6794401-.4810167 1.2301419-1.0744094 1.2301419-.5931945 0-1.0742113-.5507018-1.0742113-1.2301419v-3.0216193c0-.6792139.4810168-1.2301418 1.0742113-1.2301418z",
    fill: "#000"
  }))));
};

export { SvgDodoToken as ReactComponent };
export default __webpack_public_path__ + "44ccdce7cb83cd1c2f4b55a82fdc064e.svg";